/**
 * 文件说明:
 * ----------------------------------------
 * 创建用户: leo
 * 创建日期 2019/7/10
 */

import {query, create, update, remove} from 'crm/services/roles'
import {tree} from 'crm/services/tree'
import {treeForEach} from 'utils'
import {forEachParents} from 'crm/utils'
import createModel from 'utils/model'
import {cloneDeep} from 'lodash'

const isCheckParents = Symbol('isCheckParents')

function checkParents(activeRole, state) {
    if (activeRole && !activeRole[isCheckParents]) {
        const {flatTree} = state
        const checkArr = activeRole.modules

        if (flatTree && flatTree.length && checkArr.length) {
            let isDeleted = false
            checkArr.forEach((id) => {
                const treeNode = flatTree.find((o) => String(o.id) === String(id))
                if (treeNode && treeNode.children && treeNode.children.length) {
                    const childLen = treeNode.children.length
                    let childCheck = 0
                    treeNode.children.forEach((item) => {
                        const index = checkArr.findIndex((cid) => String(cid) === String(item.id))

                        if (index > -1) {
                            childCheck++
                        }
                    })

                    if (childLen !== childCheck) {
                        forEachParents(treeNode.children[0], (treeItem) => {
                            const index = checkArr.findIndex(
                                (cid) => String(cid) === String(treeItem.id),
                            )
                            if (index > -1) {
                                checkArr.splice(index, 1)
                                isDeleted = true
                            }
                        })
                    }
                }
            })
            if (isDeleted) {
                activeRole.modules = checkArr.slice()
            }
        }
        activeRole[isCheckParents] = true
    }
}

function filterTree(data) {
    return data
        .map((item) => {
            if (item.slug === 'crm_more') {
                return false
            }

            if (item.children) {
                return {
                    ...item,
                    children: filterTree(item.children),
                }
            }

            return item
        })
        .filter(Boolean)
}

export default createModel({
    namespace: 'crm_rolePermission',

    state: {
        roles: [],
        activeRole: null,
        tree: [],
        flatTree: [],
        privilegeMap: new Map(),
        warnModules: [],
    },

    effects: {
        *getTreeAndQuery({payload}, {select, call, put, all}) {
            const [{data: queryData}, {data: rawTreeData}] = yield all([
                call(query, payload),
                call(tree, payload),
            ])

            const flatTree = []
            const privilegeMap = new Map()
            const warnModules = []
            const treeData = filterTree(rawTreeData)

            treeForEach(treeData, (item, parent) => {
                if (item.privilege === 2) {
                    privilegeMap.set(item.id, item)
                }
                if (parent) {
                    item.parent = parent
                }
                if (item.slug === 'crm-team_management') {
                    warnModules.push(item)
                }
                flatTree.push(item)
            })

            yield put({
                type: 'setProperty',
                payload: {
                    tree: treeData,
                    flatTree,
                    privilegeMap,
                    warnModules,
                },
            })

            yield put({
                type: 'setProperty',
                payload: {
                    roles: queryData,
                },
            })

            const activeRole = yield select((state) => state.crm_rolePermission.activeRole)

            if (!activeRole && queryData[0]) {
                yield put({
                    type: 'setActiveRole',
                    payload: {
                        key: queryData[0].id,
                    },
                })
            } else {
                activeRole[isCheckParents] = false
                yield put({
                    type: 'changeActiveRole',
                    payload: activeRole,
                })
            }
        },
        *query({payload}, {select, call, put}) {
            const {data} = yield call(query, payload)

            yield put({
                type: 'setProperty',
                payload: {
                    roles: data,
                },
            })

            const activeRole = yield select((state) => state.crm_rolePermission.activeRole)

            if (!activeRole && data[0]) {
                yield put({
                    type: 'setActiveRole',
                    payload: {
                        key: data[0].id,
                    },
                })
            } else {
                activeRole[isCheckParents] = false
                yield put({
                    type: 'changeActiveRole',
                    payload: activeRole,
                })
            }
        },
        *create({payload}, {call}) {
            return yield call(create, payload)
        },
        *update({payload}, {call, put}) {
            const {data} = yield call(update, payload)
            yield put({
                type: 'changeActiveRole',
                payload: data,
            })
            return data
        },
        *remove({payload}, {call, put}) {
            const {data} = yield call(remove, payload)

            yield put({
                type: 'deleteActiveRole',
                payload: {
                    key: payload.id,
                },
            })

            return data
        },
        *updateActiveRole({payload}, {call}) {
            return yield call(update, payload)
        },
    },

    reducers: {
        setRoleSelect(state, action) {
            const {roles} = state
            const {index, select} = action.payload
            const newRoles = cloneDeep(roles)
            if (typeof select === 'boolean') {
                newRoles[index].select = select
            } else {
                newRoles[index].select = !newRoles[index].select
            }

            return {...state, ...{roles: newRoles}}
        },
        deleteActiveRole(state, action) {
            const {key} = action.payload

            if (state.activeRole.id === Number(key)) {
                return {...state, ...{activeRole: null}}
            }

            return state
        },
        setActiveRole(state, action) {
            const {key} = action.payload
            const activeRole = state.roles.find((role) => role.id === Number(key))

            if (activeRole) {
                const newActiveRole = cloneDeep(activeRole)
                checkParents(newActiveRole, state)
                return {...state, ...{activeRole: newActiveRole}}
            }
            return state
        },
        changeActiveRole(state, action) {
            const newActiveRole = {
                ...state.activeRole,
                ...action.payload,
            }
            checkParents(newActiveRole, state)
            return {
                ...state,
                ...{
                    activeRole: newActiveRole,
                },
            }
        },
    },
})
